import { render, staticRenderFns } from "./DSColorSchemePage.vue?vue&type=template&id=3f83eaa2&scoped=true&"
import script from "./DSColorSchemePage.vue?vue&type=script&lang=ts&"
export * from "./DSColorSchemePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f83eaa2",
  null
  
)

export default component.exports